import { useState, useEffect, useRef, useMemo } from "react";
import {
    FaPlus, FaMagnifyingGlass, FaTicket, FaChevronLeft, FaChevronRight,
    FaAnglesLeft, FaAnglesRight, FaFilter, FaFileExport, FaEye, FaPen,
    FaTrash, FaCopy, FaXmark, FaBolt, FaUserPlus, FaHashtag,
    FaWandMagicSparkles, FaChevronDown, FaCheck, FaRotateLeft,
    FaArrowDownShortWide, FaArrowUpShortWide, FaPrint, // <-- Tambahkan FaPrint
} from "react-icons/fa6";
import { MdOutlineConfirmationNumber, MdOutlineWifiOff } from "react-icons/md";
import { DashboardLayout } from "../../../../components/layouts/DashboardLayout";
import { VoucherGenerate } from "./generate";
import { useHookVoucher } from "../../../../hooks/useHookVoucher";
import { InternetStatus } from "../../../../components/status/internet_status";
import Pagination from "../../../../components/pagination/pagination";
import { formatDate } from "../../../../utilities/formatDate";
import { formatTimeWIB } from "../../../../utilities/formatTimeWIB";
import { FilterDrawer } from "./filter_drawer";
import { PrintConfigModal } from "./print_config_modal";
import { PrintableVoucherGrid } from "./print_table_voucer_grid";
import { renderToStaticMarkup } from "react-dom/server";

/* ============================================
   STYLE CONSTANTS
   ============================================ */
const CARD = { background: "rgba(15,23,42,0.5)", border: "1px solid rgba(51,65,85,0.3)" };

/* ============================================
   FILTER CONFIG
   ============================================ */


/* ============================================
   PRINT CONFIG & TEMPLATES
   ============================================ */

/* ============================================
   SKELETON
   ============================================ */
const SkeletonRow = ({ cols = 10 }) => (
    <tr className="animate-pulse">
        {Array.from({ length: cols }).map((_, i) => (
            <td key={i} className="px-4 py-3">
                <div className="h-3.5 bg-slate-700/60 rounded-md" style={{ width: `${40 + Math.random() * 50}%` }} />
            </td>
        ))}
    </tr>
);

/* ============================================
   STATUS BADGE
   ============================================ */
const StatusBadge = ({ status }) => {
    const c = {
        active: { bg: "bg-emerald-500/12", text: "text-emerald-400", border: "border-emerald-500/20", dot: "bg-emerald-500" },
        aktif: { bg: "bg-emerald-500/12", text: "text-emerald-400", border: "border-emerald-500/20", dot: "bg-emerald-500" },
        used: { bg: "bg-amber-500/12", text: "text-amber-400", border: "border-amber-500/20", dot: "bg-amber-500" },
        terpakai: { bg: "bg-amber-500/12", text: "text-amber-400", border: "border-amber-500/20", dot: "bg-amber-500" },
        nonaktif: { bg: "bg-red-500/12", text: "text-red-400", border: "border-red-500/20", dot: "bg-red-500" },
    }[status] || { bg: "bg-slate-500/12", text: "text-slate-400", border: "border-slate-500/20", dot: "bg-slate-500" };

    return (
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold tracking-wide border ${c.bg} ${c.text} ${c.border}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />{status}
        </span>
    );
};

/* ============================================
   COPY TOAST
   ============================================ */
const CopyToast = ({ show, text }) => {
    if (!show) return null;
    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none">
            <div className="flex items-center gap-2.5 px-5 py-3 rounded-xl shadow-2xl shadow-emerald-500/10 border border-emerald-500/20"
                style={{ background: "linear-gradient(135deg, rgba(6,78,59,0.92), rgba(15,23,42,0.95))", backdropFilter: "blur(16px)", animation: "copyToastIn 0.35s cubic-bezier(0.16,1,0.3,1) forwards" }}>
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-emerald-500/20"><FaCheck className="text-emerald-400 text-xs" /></span>
                <span className="text-sm font-medium text-emerald-300 whitespace-nowrap">{text} berhasil disalin</span>
                <style>{`@keyframes copyToastIn{0%{opacity:0;transform:translateY(16px) scale(0.95)}100%{opacity:1;transform:translateY(0) scale(1)}}`}</style>
            </div>
        </div>
    );
};

/* ============================================
   FILTER CHIP
   ============================================ */
const FilterChip = ({ label, onRemove }) => (
    <span className="inline-flex items-center gap-1.5 pl-2.5 pr-1.5 py-1 rounded-lg text-[11px] font-semibold cursor-default"
        style={{ background: "rgba(0,180,216,0.08)", border: "1px solid rgba(0,180,216,0.2)", color: "#22d3ee" }}>
        {label}
        <button onClick={onRemove} className="p-0.5 rounded-md hover:bg-cyan-400/20 transition-colors"><FaXmark size={10} /></button>
    </span>
);

/* ============================================
   FILTER DRAWER
   ============================================ */


/* ============================================
   PRINT CONFIG MODAL (NEW FITUR)
   ============================================ */
const FILTER_DEFAULTS = {
    mitra_id: "",
    reseller_id: "",
    profile_id: "",
    status: "",
    date_from: "",
    date_to: "",
    sort_by: "created_at",
    sort_dir: "desc",
};


/* ============================================
   KOMPONEN UTAMA
   ============================================ */
export const VocherPage = () => {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedIds, setSelectedIds] = useState([]);
    const [copied, setCopied] = useState({ show: false, text: "" });
    const [openFilter, setOpenFilter] = useState(false);
    const [showAddMenu, setShowAddMenu] = useState(false);
    const [showGenerateModal, setShowGenerateModal] = useState(false);
    const [showSingleModal, setShowSingleModal] = useState(false);
    const addMenuRef = useRef(null);

    // Print State
    const [showPrintModal, setShowPrintModal] = useState(false);

    // Single form states (tidak diubah, tetap di sini)
    const [singleProfile, setSingleProfile] = useState("");
    const [singleUsername, setSingleUsername] = useState("");
    const [singlePassword, setSinglePassword] = useState("");
    const [singleMitra, setSingleMitra] = useState("");
    const [singleReseler, setSingleReseler] = useState("");
    const [saveToast, setSaveToast] = useState({ show: false, msg: "" });

    const { data, loading, meta, params, setParams, refreshData } = useHookVoucher();

    /* ── Outside click close dropdown ── */
    useEffect(() => {
        const handler = (e) => { if (addMenuRef.current && !addMenuRef.current.contains(e.target)) setShowAddMenu(false); };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    /* ── Helpers ── */
    const copy = (text, label) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied({ show: true, text: label || text });
            setTimeout(() => setCopied({ show: false, text: "" }), 2000);
        });
    };

    const handleFilterApply = (filterForm) => {
        setParams((prev) => ({ ...prev, ...filterForm, page: 1 }));
    };

    const handleFilterReset = () => {
        setParams((prev) => ({ ...prev, ...FILTER_DEFAULTS, page: 1 }));
    };

    const activeFilterCount = [
        "mitra_id", "reseller_id", "profile_id", "status", "date_from", "date_to",
    ].filter((k) => params[k] && params[k] !== "").length;

    const toggleSelect = (id) => setSelectedIds((p) => p.includes(id) ? p.filter((x) => x !== id) : [...p, id]);
    const toggleSelectAll = () => setSelectedIds((p) => (p.length === data.length ? [] : data.map((x) => x.id)));

    const getPages = () => {
        if (!meta) return [];
        const { last_page: total, current_page: current } = meta;
        const delta = 2, pages = [], left = Math.max(2, current - delta), right = Math.min(total - 1, current + delta);
        pages.push(1);
        if (left > 2) pages.push("...");
        for (let i = left; i <= right; i++) pages.push(i);
        if (right < total - 1) pages.push("...");
        if (total > 1) pages.push(total);
        return pages;
    };

    /* ── PRINT LOGIC ── */
    /* ── PRINT LOGIC ── */
    const handlePrint = (config) => {
        const vouchersToPrint = selectedIds.length > 0
            ? data.filter(v => selectedIds.includes(v.id))
            : data;

        if (vouchersToPrint.length === 0) {
            alert("Tidak ada voucher untuk dicetak");
            return;
        }

        // Buka tab baru
        const printWindow = window.open('', '_blank');
        const pageBreak = config.paperSize === 'A5' ? 'size: A5 landscape;' : `size: ${config.paperSize} portrait;`;

        /* ============================================
           TEMPLATE CONFIGURATIONS
           ============================================ */
        const TEMPLATES = {
            standard: {
                render: (vouchers, cols) => {
                    const gridCols = `repeat(${cols}, 1fr)`;
                    return vouchers.map(v => `
                        <div style="padding: 15px; border: 1px dashed #ccc; border-radius: 8px; page-break-inside: avoid;">
                            <div style="font-size: 14px; font-weight: bold; margin-bottom: 8px; color: #0891b2;">${v.profile?.name || 'Voucher'}</div>
                            <div style="font-size: 12px; margin-bottom: 4px;"><strong>Username:</strong> ${v.username}</div>
                            <div style="font-size: 12px; margin-bottom: 4px;"><strong>Password:</strong> ${v.password}</div>
                            <div style="font-size: 10px; color: #64748b; margin-top: 8px;">Status: ${v.status} | Mitra: ${v.mitra?.name || '-'}</div>
                        </div>
                    `).join('');
                },
                wrapperStyle: (cols) => `display: grid; grid-template-columns: repeat(${cols}, 1fr); gap: 15px; padding: 10mm;`
            },
            minimal: {
                render: (vouchers, cols) => {
                    return vouchers.map(v => `
                        <div style="padding: 10px; border-bottom: 1px solid #e2e8f0; page-break-inside: avoid;">
                            <div style="font-family: monospace; font-size: 14px; letter-spacing: 1px; margin-bottom: 4px;">${v.username}</div>
                            <div style="font-family: monospace; font-size: 14px; letter-spacing: 1px; color: #64748b;">${v.password}</div>
                        </div>
                    `).join('');
                },
                wrapperStyle: (cols) => `display: grid; grid-template-columns: repeat(${cols}, 1fr); gap: 15px; padding: 10mm;`
            },
            card: {
                render: (vouchers, cols) => {
                    return vouchers.map(v => `
                        <div style="padding: 0; border: 2px solid #0f172a; border-radius: 12px; overflow: hidden; page-break-inside: avoid;">
                            <div style="background: #0f172a; color: #fff; padding: 8px 15px; font-size: 12px; font-weight: bold;">${v.profile?.name || 'Voucher'}</div>
                            <div style="padding: 15px;">
                                <div style="font-family: monospace; font-size: 16px; font-weight: bold; margin-bottom: 6px;">${v.username}</div>
                                <div style="font-family: monospace; font-size: 16px; font-weight: bold; color: #0891b2;">${v.password}</div>
                            </div>
                        </div>
                    `).join('');
                },
                wrapperStyle: (cols) => `display: grid; grid-template-columns: repeat(${cols}, 1fr); gap: 15px; padding: 10mm;`
            },

            // TEMPLATE KARTU: React Component
            custom_card: {
                render: (vouchers, cols) => {
                    return renderToStaticMarkup(<PrintableVoucherGrid vouchers={vouchers} columns={cols} />);
                },
                wrapperStyle: () => `` // Kosongkan karena layout A4 diatur dalam component
            }
        };

        const selectedTemplate = TEMPLATES[config.template] || TEMPLATES.standard;
        const htmlContent = selectedTemplate.render(vouchersToPrint, config.columns);
        const wrapperCss = selectedTemplate.wrapperStyle(config.columns);

        // Tulis HTML ke tab baru
        printWindow.document.write(`
            <html>
            <head>
                <title>Preview Cetak Voucher</title>
                <style>
                    @page { ${pageBreak} margin: 0; }
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; margin: 0; padding: 20px; background: #f1f5f9; color: #0f172a; display: flex; flex-direction: column; align-items: center; }
                    .grid-container { ${wrapperCss} width: 100%; }
                    
                    /* Force browser to print colors and backgrounds */
                    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }

                    /* Styling Tombol Cetak */
                    .print-button-wrapper {
                        position: sticky;
                        top: 0;
                        z-index: 9999;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        padding: 15px 0;
                        background: linear-gradient(to bottom, #f1f5f9 80%, transparent 100%);
                    }
                    .print-btn {
                        padding: 12px 32px;
                        background: #0e7490;
                        color: white;
                        border: none;
                        border-radius: 8px;
                        font-size: 16px;
                        font-weight: bold;
                        cursor: pointer;
                        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                        transition: background 0.2s;
                    }
                    .print-btn:hover {
                        background: #0891b2;
                    }
                </style>
            </head>
            <body>
                <!-- Tombol Cetak (akan hilang saat print karena class no-print di component) -->
                <div class="print-button-wrapper no-print">
                    <button class="print-btn no-print" onclick="window.print()">Cetak Voucher</button>
                </div>

                <div class="grid-container">
                    ${htmlContent}
                </div>
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        setShowPrintModal(false);
    };

    const columns = [
        { key: "no", label: "No", align: "center", width: "56px" },
        { key: "status", label: "Status", align: "center", },
        { key: "inet", label: "Inet", align: "center", },
        { key: "username", label: "Username", align: "left" },
        { key: "password", label: "Password", align: "left" },
        { key: "profile", label: "Profile / Harga", align: "left" },
        { key: "start", label: "Start Login", align: "left" },
        { key: "expired", label: "Expired", align: "left" },
        { key: "mitra", label: "Mitra", align: "left" },
        { key: "reseler", label: "Reseler", align: "left" },
        { key: "created_by", label: "Created By", align: "left" },
        { key: "action", label: "Aksi", align: "center", width: "100px" },
    ];

    /* ============================================
       RENDER
       ============================================ */
    return (
        <>
            <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
                {/* ===== STICKY HEADER ===== */}
                <header className="sticky top-0 z-40 px-4 lg:px-6 py-3.5 flex items-center justify-between"
                    style={{ background: "rgba(2,6,23,0.8)", borderBottom: "1px solid rgba(51,65,85,0.3)", backdropFilter: "blur(16px)" }}>

                    <div className="flex items-center gap-3 flex-wrap">
                        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-cyan-500/10 border border-cyan-500/20">
                            <MdOutlineConfirmationNumber className="text-cyan-400" />
                        </div>
                        <div>
                            <h2 className="text-base md:text-lg font-bold text-gray-100 leading-tight">Management Voucher</h2>
                            <p className="text-[11px] text-slate-500 hidden sm:block">Kelola data voucher PPPoE untuk pelanggan</p>
                        </div>
                        {meta && (
                            <span className="hidden sm:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/10 text-cyan-400 border border-cyan-500/20">
                                {meta.total} data
                            </span>
                        )}
                        {selectedIds.length > 0 && (
                            <span className="hidden sm:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-500/10 text-red-400 border border-red-500/20">
                                {selectedIds.length} dipilih
                            </span>
                        )}
                    </div>

                    <div className="flex gap-2">
                        {/* Tombol Print (Gantikan Export atau tambahkan berdampingan) */}
                        <button onClick={() => setShowPrintModal(true)} className="flex items-center gap-2 px-3.5 py-2 rounded-xl text-sm font-medium text-slate-300 hover:text-gray-100 transition-all"
                            style={{ background: "rgba(30,41,59,0.6)", border: "1px solid rgba(51,65,85,0.4)" }}>
                            <FaPrint className="text-xs" /><span className="hidden lg:inline">Cetak</span>
                        </button>

                        {/* Dropdown Tambah */}
                        <div className="relative" ref={addMenuRef}>
                            <button onClick={() => setShowAddMenu(!showAddMenu)}
                                className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold text-white shadow-lg shadow-cyan-600/20 hover:shadow-cyan-600/30 transition-all"
                                style={{ background: "linear-gradient(135deg,#0891b2,#0e7490)" }}>
                                <FaPlus className="text-xs" /><span className="hidden lg:inline">Tambah Voucher</span><FaChevronDown className="text-[10px] ml-0.5" />
                            </button>
                            {showAddMenu && (
                                <div className="absolute right-0 top-full mt-2 w-56 rounded-xl overflow-hidden shadow-2xl z-50"
                                    style={{ background: "rgba(15,23,42,0.98)", border: "1px solid rgba(51,65,85,0.4)", backdropFilter: "blur(16px)" }}>
                                    <button onClick={() => { setShowAddMenu(false); setShowGenerateModal(true); }}
                                        className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm text-slate-200 hover:bg-cyan-500/10 hover:text-cyan-300 transition-all"
                                        style={{ borderBottom: "1px solid rgba(51,65,85,0.2)" }}>
                                        <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(6,182,212,0.12)", border: "1px solid rgba(6,182,212,0.15)" }}><FaBolt className="text-cyan-400 text-xs" /></div>
                                        <div><div className="font-semibold">Generate Batch</div><div className="text-[10px] text-slate-500">Buat banyak voucher sekaligus</div></div>
                                    </button>
                                    <button onClick={() => { setShowAddMenu(false); setShowSingleModal(true); }}
                                        className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm text-slate-200 hover:bg-violet-500/10 hover:text-violet-300 transition-all">
                                        <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(139,92,246,0.12)", border: "1px solid rgba(139,92,246,0.15)" }}><FaUserPlus className="text-violet-400 text-xs" /></div>
                                        <div><div className="font-semibold">Tambah Satuan</div><div className="text-[10px] text-slate-500">Input manual atau generate 1 voucher</div></div>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* ===== CONTENT ===== */}
                <main className="p-4 lg:p-6 space-y-5">

                    {/* ── Sticky Search + Filter Bar ── */}
                    <div className="flex items-center gap-3">
                        <div className="relative flex-1">
                            <FaMagnifyingGlass className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 text-sm" />
                            <input type="text" placeholder="Cari username, password, mitra..."
                                value={params?.search}
                                onChange={(e) => setParams((p) => ({ ...p, search: e.target.value, page: 1 }))}
                                className="w-full pl-10 pr-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all" />
                        </div>

                        {/* Filter Button + Badge */}
                        <button onClick={() => setOpenFilter(true)}
                            className="relative flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all flex-shrink-0"
                            style={{ background: activeFilterCount > 0 ? "rgba(0,180,216,0.12)" : "rgba(51,65,85,0.2)", border: activeFilterCount > 0 ? "1px solid rgba(0,180,216,0.3)" : "1px solid rgba(51,65,85,0.3)", color: activeFilterCount > 0 ? "#22d3ee" : "#94a3b8" }}>
                            <FaFilter className="text-xs" />
                            <span className="hidden sm:inline">Filter</span>
                            {activeFilterCount > 0 && (
                                <span className="flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-black" style={{ background: "#22d3ee", color: "#0f172a" }}>
                                    {activeFilterCount}
                                </span>
                            )}
                        </button>

                        {/* Quick Reset */}
                        {activeFilterCount > 0 && (
                            <button onClick={handleFilterReset}
                                className="flex items-center gap-1.5 px-3 py-2.5 rounded-xl text-xs font-semibold text-red-400 transition-all flex-shrink-0"
                                style={{ background: "rgba(239,68,68,0.06)", border: "1px solid rgba(239,68,68,0.15)" }}
                                title="Hapus semua filter">
                                <FaRotateLeft size={11} /><span className="hidden sm:inline">Reset</span>
                            </button>
                        )}
                    </div>

                    {/* ── Active Filter Chips ── */}
                    {activeFilterCount > 0 && (
                        <div className="flex flex-wrap items-center gap-2">
                            {params.mitra_id && <FilterChip label={`Mitra: ${params.mitra_id}`} onRemove={() => setParams((p) => ({ ...p, mitra_id: "", page: 1 }))} />}
                            {params.reseller_id && <FilterChip label={`Reseller: ${params.reseller_id}`} onRemove={() => setParams((p) => ({ ...p, reseller_id: "", page: 1 }))} />}
                            {params.profile_id && <FilterChip label={`Profile: ${params.profile_id}`} onRemove={() => setParams((p) => ({ ...p, profile_id: "", page: 1 }))} />}
                            {params.status && <FilterChip label={`Status: ${params.status}`} onRemove={() => setParams((p) => ({ ...p, status: "", page: 1 }))} />}
                            {params.date_from && <FilterChip label={`Dari: ${params.date_from}`} onRemove={() => setParams((p) => ({ ...p, date_from: "", page: 1 }))} />}
                            {params.date_to && <FilterChip label={`Sampai: ${params.date_to}`} onRemove={() => setParams((p) => ({ ...p, date_to: "", page: 1 }))} />}
                        </div>
                    )}

                    {/* ── Desktop Table ── */}
                    <section className="hidden lg:block rounded-2xl overflow-hidden" style={CARD}>
                        <div className="overflow-x-auto">
                            <table className="min-w-max max-w-2xl text-sm">
                                <thead>
                                    <tr className="border-b" style={{ background: "rgba(15,23,42,0.7)", borderColor: "rgba(51,65,85,0.3)" }}>
                                        <th className="px-4 py-3.5 text-center w-12">
                                            <input type="checkbox" checked={selectedIds.length === data.length && data.length > 0} onChange={toggleSelectAll}
                                                className="w-4 h-4 rounded border-slate-600 bg-slate-800 text-cyan-500 focus:ring-cyan-500/30 focus:ring-offset-0 cursor-pointer" />
                                        </th>
                                        {columns.map((col) => (
                                            <th key={col.key} className={`px-4 py-3.5 text-xs font-semibold uppercase tracking-wider text-slate-400 ${col.align === "center" ? "text-center" : "text-left"}`}
                                                style={col.width ? { width: col.width } : undefined}>{col.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="divide-y" style={{ borderColor: "rgba(51,65,85,0.15)" }}>
                                    {loading && <>{[...Array(5)].map((_, i) => <SkeletonRow key={i} cols={columns.length} />)}</>}

                                    {!loading && data?.length === 0 && (
                                        <tr>
                                            <td colSpan={columns.length + 1} className="px-4 py-16 text-center">
                                                <div className="flex flex-col items-center gap-3">
                                                    <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: "rgba(51,65,85,0.2)", border: "1px solid rgba(51,65,85,0.2)" }}>
                                                        <FaTicket className="text-2xl text-slate-600" />
                                                    </div>
                                                    <div>
                                                        <p className="text-slate-400 font-medium">Tidak ada data ditemukan</p>
                                                        <p className="text-xs text-slate-500 mt-1">
                                                            {params?.search || activeFilterCount > 0 ? "Coba ubah filter atau kata kunci pencarian" : "Belum ada voucher yang terdaftar"}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}

                                    {!loading && data?.map((item, index) => (
                                        <tr key={item.id} className="transition-colors duration-150 hover:bg-cyan-500/[0.03]">
                                            <td className="px-4 py-3 text-center">
                                                <input type="checkbox" checked={selectedIds.includes(item.id)} onChange={() => toggleSelect(item.id)}
                                                    className="w-4 h-4 rounded border-slate-600 bg-slate-800 text-cyan-500 focus:ring-cyan-500/30 focus:ring-offset-0 cursor-pointer" />
                                            </td>
                                            <td className="px-4 py-3 text-center text-slate-500 font-mono text-xs">{meta.from + index}</td>
                                            <td className="px-4 py-3 text-center capitalize">
                                                <StatusBadge status={item?.status} />
                                            </td>
                                            <td className="px-4 py-3 text-center ">
                                                {item?.status === "aktif" && item?.internet_status === "online" ? (
                                                    <InternetStatus />
                                                ) : item?.status === "nonaktif" || (item?.status === "aktif" && item?.internet_status === "offline") ? (
                                                    <MdOutlineWifiOff className="text-xl text-red-500" />
                                                ) : (
                                                    <MdOutlineWifiOff className="text-xl text-amber-500" />
                                                )}
                                            </td>
                                            <td className="px-4 py-3 cursor-pointer hover:text-cyan-400 transition-colors group"
                                                onClick={() => copy(item?.username, "Username")} title="Klik untuk copy">
                                                <span className="font-mono text-sm text-cyan-400/90">{item?.username || "—"}</span>
                                            </td>
                                            <td className="px-4 py-3 cursor-pointer hover:text-cyan-400 transition-colors group"
                                                onClick={() => copy(item?.password, "Password")} title="Klik untuk copy">
                                                <span className="font-mono text-sm text-slate-300">{item?.password || "—"}</span>
                                            </td>
                                            <td className="px-4 py-3">
                                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-lg text-xs font-medium bg-violet-500/10 text-violet-400 border border-violet-500/15">
                                                    {item?.profile?.name || "—"}
                                                </span>
                                            </td>
                                            <td className="px-4 py-3">
                                                {formatTimeWIB(item?.first_login_at)}   {formatDate(item?.first_login_at)}
                                            </td>
                                            <td className="px-4 py-3">
                                                {formatTimeWIB(item?.expired_at)}   {formatDate(item?.expired_at)}
                                            </td>
                                            <td className="px-4 py-3 text-slate-300 min-w-[130px]">{item?.mitra?.name || <span className="text-slate-600 italic">—</span>}</td>
                                            <td className="px-4 py-3 text-slate-300 min-w-[130px]">{item?.reseller?.name || <span className="text-slate-600 italic">—</span>}</td>
                                            <td className="px-4 py-3">
                                                <div className="flex items-center gap-2">
                                                    <div className="w-6 h-6 rounded-full bg-slate-700/60 flex items-center justify-center text-[10px] font-bold text-slate-400 uppercase">
                                                        {item?.created_by?.charAt(0) || "—"}
                                                    </div>
                                                    <span className="text-slate-300 text-xs">{item?.created_by || "—"}</span>
                                                </div>
                                            </td>
                                            <td className="px-4 py-3 text-center">
                                                <div className="flex items-center justify-center gap-1">
                                                    <button className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-cyan-500/10 transition-all" title="Detail"><FaEye className="text-xs" /></button>
                                                    <button className="p-2 rounded-lg text-slate-400 hover:text-amber-400 hover:bg-amber-500/10 transition-all" title="Edit"><FaPen className="text-xs" /></button>
                                                    <button className="p-2 rounded-lg text-slate-400 hover:text-red-400 hover:bg-red-500/10 transition-all" title="Hapus"><FaTrash className="text-xs" /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <Pagination meta={meta} params={params} setParams={setParams} />
                    </section>

                    {/* ── Mobile Cards (optional, uncomment if needed) ── */}
                </main>
            </DashboardLayout>

            {/* ===== DRAWERS & MODALS ===== */}
            <FilterDrawer open={openFilter} setOpen={setOpenFilter} currentParams={params} onApply={handleFilterApply} FILTER_DEFAULTS={FILTER_DEFAULTS} />
            <PrintConfigModal
                open={showPrintModal}
                setOpen={setShowPrintModal}
                onPrint={handlePrint}
                selectedCount={selectedIds.length}
            />
            <VoucherGenerate showModal={showGenerateModal} setShowModal={setShowGenerateModal} refreshData={refreshData} />

            {/* Single Modal (tetap seperti sebelumnya, tidak diubah) */}
            {/* ... single modal code tetap di sini ... */}

            {/* ===== TOASTS ===== */}
            <CopyToast show={copied.show} text={copied.text} />
            {saveToast.show && (
                <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100]">
                    <div className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-medium text-emerald-300 shadow-xl shadow-emerald-500/10"
                        style={{ background: "rgba(6,78,59,0.9)", border: "1px solid rgba(16,185,129,0.25)", backdropFilter: "blur(12px)", animation: "copyToastIn 0.3s ease" }}>
                        <FaCheck className="text-xs" />{saveToast.msg}
                    </div>
                    <style>{`@keyframes copyToastIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}`}</style>
                </div>
            )}
        </>
    );
};